import React from 'react';
import { InputNumber } from 'antd';
import type { InputNumberProps } from 'antd/lib/input-number';
import styled from 'types/theme.types';
import { getCommonInputCssFromProps } from 'components/common/input-components/common-styles';
import omit from 'lodash/omit';

export interface NumberInputProps extends InputNumberProps {
  invalid?: boolean;
}

const NumberInput: React.FC<NumberInputProps> = ({ ...props }) => <StyledNumberInput {...omit(props, ['hideError'])} />;

// Unspecced in Figma: extrapolated from Input through the shared antd block, which also drives the
// stepper chrome.
const StyledNumberInput = styled(InputNumber)<NumberInputProps>`
  ${getCommonInputCssFromProps}

  && .ant-input-number-input::placeholder {
    color: var(--component-field-text-placeholder);
  }

  &&:hover .ant-input-number-input::placeholder {
    color: var(--component-field-text-placeholder-hover);
  }

  &&.ant-input-number-focused .ant-input-number-input::placeholder {
    color: var(--component-field-text-placeholder-active);
  }
`;

export default NumberInput;
